import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22useCustomFonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/fonts/GT-Planar-Regular.woff%22,%22style%22:%22normal%22}],%22variable%22:%22--font-gt-planar%22}],%22variableName%22:%22planarGt%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'planarGt', 'planarGt Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
